import React, { useState, useEffect, useRef, memo } from "react";
import { Button, Col, Row, Container, Card, Spinner } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { getSignedUrl, trackVideoProgress } from "ServerAPI/serverAPI";
import VideoRender from "./VideoRender";
import { useCookies } from "react-cookie";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-dash";
import { ROLES } from "constants/Constants";

const VideoPlayer = ({ 
  activeContent, 
  fileName, 
  videoProgress 
}) => {
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const { courseId, sectionId } = useParams();
  const [cookies] = useCookies();
  const [objectUrl, setObjectUrl] = useState("");
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [videoDuration, setVideoDuration] = useState(0); // NEW STATE VARIABLE HERE

  useEffect(() => {
    const getVideo = async () => {
      setLoading(true);
      const payload = {
        courseId: courseId,
        sectionId: sectionId,
        fileName: fileName,
        method: "GET",
        userId: cookies?.userId,
      };
      try {
        const response = await getSignedUrl(payload);
        const generatedUrl = response.data.preSignedUrl;
        setObjectUrl(response?.data?.objectUrl);
        setVideoUrl(generatedUrl);
      } catch (error) {
        console.error("Error fetching the video URL:", error);
      }
      setLoading(false);
    };

    getVideo();
  }, [courseId, sectionId, fileName]);

  const saveVideoProgress = async (type = "onPause") => {
        // check if current video watch time is greater than saved video progress time

        let isCurrentVideoWatchTimeGreater = false;

    if (activeContent?.progressTime) {
      if (activeContent?.progressTime < videoProgress.current) {
        isCurrentVideoWatchTimeGreater = true;
      } else {
        isCurrentVideoWatchTimeGreater = false;
      }
    } else {
      isCurrentVideoWatchTimeGreater = true;
    }
    if (
      cookies.roleId === ROLES.COURSE_PARTICIPANT &&
      videoProgress.current > 0 &&
      !activeContent?.completed &&
      isCurrentVideoWatchTimeGreater
    ) {
      const payload = {
        courseId,
        sectionId,
        contentId: activeContent?.contentId,
        contentName: activeContent.contentFileName,
        progressTime: videoProgress.current,
        userId: cookies.userId,
        type,
        isCompleted: activeContent?.completedStatus
          ? activeContent?.completedStatus
          : Math.floor(videoDuration) === Math.floor(videoProgress.current), // Use the state variable
        duration: Math.floor(videoDuration), // Use the state variable
      };

      await trackVideoProgress(payload);
    }
  };

  useEffect(() => {
    return () => {
      saveVideoProgress("onVideoChange");
    };
  }, [activeContent, videoDuration]); // Trigger cleanup when videoDuration changes

  useEffect(() => {
    if (videoRef.current) {
      playerRef.current = videojs(videoRef.current, {
        controls: true,
        autoplay: false,
        preload: "auto",
        techOrder: ["html5"],
        sources: [
          {
            src: videoUrl,
            type: "application/dash+xml",
          },
        ],
      });
    }
  }, [videoUrl]);
  // save the video progress time when tab is closed or browser is closed

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      saveVideoProgress("onTabClose");
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);

    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, [videoDuration]); // Trigger on tab close when videoDuration changes

  return (
    <section className="mt-6 course-container">
      <Container fluid>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <div className="content">
              <div>
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center w-100 h-100 course-container">
                    <Spinner />
                  </div>
                ) : (
                  <div
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                    }}
                  >
                    <VideoRender
                      url={videoUrl}
                      fileName={objectUrl}
                      videoProgress={videoProgress}
                      activeContent={activeContent}
                      setVideoDuration={setVideoDuration} 
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default VideoPlayer;